import { io, type Socket } from 'socket.io-client';
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from '@livepuls/types';

type PanelSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: PanelSocket | null = null;
let registeredPanelId: string | null = null;

/**
 * Lazy Singleton. Beim ersten Aufruf wird der Socket aufgebaut. Sobald
 * eine panelId bekannt ist, wird `panel:register` ausgelöst – auch bei
 * Reconnects, daher der Listener auf 'connect'.
 */
export function getSocket(): PanelSocket {
  if (socket) return socket;
  socket = io({
    autoConnect: true,
    transports: ['websocket'],
  });
  socket.on('connect', () => {
    if (registeredPanelId) {
      socket?.emit('panel:register', { panelId: registeredPanelId, type: 'panel' });
    }
  });
  socket.on('connect_error', (err) => {
    console.warn('[socket] connect_error', err.message);
  });
  return socket;
}

export function registerAsPanel(panelId: string): void {
  registeredPanelId = panelId;
  const s = getSocket();
  if (s.connected) {
    s.emit('panel:register', { panelId, type: 'panel' });
  }
}
